import { LDProvider } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

const LaunchDarklyProvider = ({ children }) => {
  const [clientSideID, setClientSideID] = useState("");
  const [key, setKey] = useState("");

  useEffect(() => {
    setClientSideID(process.env.LAUNCHDARKLY_CLIENT_ID);
    const anonymousId = generateAnonymousId();
    setKey(anonymousId);
  }, []);

  const generateAnonymousId = () => {
    if (typeof window !== "undefined") {
      let anonymousId = localStorage.getItem("anonymousId");
      if (!anonymousId) {
        anonymousId = new Date().getTime();
        localStorage.setItem("anonymousId", anonymousId);
      }
      return anonymousId;
    }
    return null;
  };

  if (!clientSideID) {
    return null; // or a loading indicator
  }

  return (
    <LDProvider
      clientSideID={clientSideID}
      context={{
        key: key, // Replace this with a unique identifier for the user
        anonymous: true // You can change this based on your user data
      }}
    >
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyProvider;
